import type { TransitionStatus } from 'react-transition-group/Transition';
import styled, { css } from 'styled-components';

import Spinner from '#@/components/Spinner';
import { COLOR } from '#@/shared/utils/styles';
import { zIndexValues } from '#@/shared/utils/styles/zIndexValues';
import { isEntered } from '#@/shared/utils/transitionStates';

import { BackdropContainer } from './components/BackdropContainer';
import { TOOLBAR_HEIGHT, TRANSITION_DURATION } from './constants';

export const Container = styled(BackdropContainer)<{ $transitionState: TransitionStatus }>`
  background-color: ${(props) =>
    isEntered(props.$transitionState) ? COLOR.modalOverlay : 'transparent'};
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  transition: background-color ${TRANSITION_DURATION}ms linear;
  width: 100%;
  z-index: ${zIndexValues.lightbox};
`;

const loadingIndicatorSize = 64;

export const LoadingIndicator = styled(Spinner).attrs({
  size: loadingIndicatorSize,
  color: COLOR.white,
})<{ $transitionState: TransitionStatus }>`
  left: calc(50% - ${loadingIndicatorSize / 2}px);
  opacity: ${({ $transitionState }) => (isEntered($transitionState) ? 1 : 0)};
  pointer-events: none;
  position: fixed;
  top: calc(50% - ${loadingIndicatorSize / 2}px + ${TOOLBAR_HEIGHT / 2}px);
  transition: opacity ${TRANSITION_DURATION / 2}ms ${TRANSITION_DURATION / 2}ms ease-out;
`;

interface ContentProps {
  $isLoading: boolean;
}

export const Content = styled.div<ContentProps>`
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  transition: ${TRANSITION_DURATION}ms ease-out;
  transition-property: transform, opacity;
  width: 100%;

  ${(props) =>
    props.$isLoading
      ? css`
          opacity: 0;
          pointer-events: none;
          transform: translateY(20px);
        `
      : css`
          opacity: 1;
          transform: translateY(0);
        `};
`;
